import { authFetch } from "lib/api/authFetch";
import { BACKEND_URL } from "lib/utils/baseUrl";

export async function updateOrganizationUserPermission(id, payload) {
  try {
    const response = await authFetch(`${BACKEND_URL}/organization/users/${id}/permission`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });

    const data = await response.json().catch(() => ({}));
    return {
      success: response.ok && data?.success === true,
      message: data?.message ?? "",
      data: data?.data ?? null,
    };
  } catch (error) {
    console.error("[updateOrganizationUserPermission] failed:", error);
    return {
      success: false,
      message: "사용자 권한 저장 중 오류가 발생했습니다.",
      data: null,
    };
  }
}
